import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { LoadAddEditService } from 'src/app/services/load-add-edit.service';

@Component({
  selector: 'app-breaks',
  templateUrl: './breaks.component.html',
  styleUrls: ['./breaks.component.css'],
  template: '{{loadAddEditService.getControls()}}'
})
export class BreaksComponent implements OnInit {

  childForm: FormGroup;

  /**
   * Just for example
   */
  @Input("appleForm")
  form: FormGroup;

  break: FormGroup;

  breakTimes: FormArray;
  extraFacilities: FormArray;


  constructor(private fb: FormBuilder,
    private loadAddEditService: LoadAddEditService,) { }

  ngOnInit(): void {
    this.break = this.loadAddEditService.breakForm;
    this.breakTimes = this.loadAddEditService.breakTimes;
    this.extraFacilities = this.loadAddEditService.extraFacilitiesForm;
  }

  changeLogon(){
    this.form.controls['logon'].patchValue("Hitman");
    let formGroup: FormGroup = new FormGroup({'apple': new FormControl([{value: 'India', disabled: true}])});
    this.form.addControl('apple',formGroup);
  }

  public submitForm(form: FormGroup) {
    // this.isSubmitted = true;
    console.log('Valid?',form.valid);
    console.log('Logon from break',form.value.logon);
    console.log('productName from break',form.value.productName);
    console.log('scac from break',form.value.scac);
    this.loadAddEditService.submitValue(form.value);
  }

  // get breakTime(): FormArray{
  //   return this.break.controls['breaks'] as FormArray;
  // }

  // get breakTimes(): FormArray{
  //   return this.break.controls['breakTimes'] as FormArray;
  // }
  getExtraFacilities(i): FormArray{return this.breakTimes.controls[i].get('extraFacilities') as FormArray}

  addBreakTime(){
    this.loadAddEditService.addBreakTime();
   // this.breakTimes = this.loadAddEditService.breakTimeForm;
  }

  addExtraTime(i){
    this.loadAddEditService.addExtraTime(i);
  }
}
